import classNames from 'classnames';
import React from 'react';

type Props = {
  children: React.ReactNode;
  mt?: number;
  mb?: number;
  my?: number;
  className?: string;
};

const BlockTitle = (props: Props) => {
  const { mt, mb, my, className } = props;

  return (
    <h3
      className={classNames('block-title', className, {
        [`mt-${mt}-i`]: mt || mt === 0,
        [`mb-${mb}-i`]: mb || mb === 0,
        [`my-${my}-i`]: my || my === 0,
      })}
    >
      {props.children}
    </h3>
  );
};

export default BlockTitle;
